import { ReactNode, useEffect, useMemo, useRef, useState } from "react";

interface StatedProps
{
    states : State[];
    check ?: number;
    id ?: string;
}

class State
{
    index : number = 0;
    node : ReactNode = null;
    check : () => boolean = () => { return false; };  
    canSkipTo ?: boolean = false;
    canReturnTo ?: boolean = false;
}


export function Stated (props: StatedProps)
{
    const state = useRef<State>(props.states[0]);

    const s = useMemo(() => {
        if (props.id !== undefined)
            console.log("re-render " + props.id + ", " + state.current.index);
        for (let i = props.states.length - 1; i >= 0; i--)
        {
            const checkState = props.states[i];
            if (checkState.index == state.current.index)
                continue;
            const canCheck = checkState.index == state.current.index + 1 || checkState.canSkipTo || checkState.canReturnTo;
            if (!canCheck)
                continue;
            const checkValid : boolean = checkState.check();
            if (!checkValid)
                continue;
            state.current = checkState;
            return checkState;
        }
        return state.current;
    }, [props.check]);

    return s.node;
}